import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Update a folder's position in the sort order
 * @param {Object} config
 * @param {number} config.id - The folder ID
 * @param {number} config.position - The new position for the folder; positions are 1-based
 */
const updateFolderPosition = ({ id, position }) =>
  xhr({
    url: `${foldersEndpoint}/${id}`,
    method: 'PUT',
    data: {
      folder: {
        position,
      },
    },
  })

export default updateFolderPosition
